<template>
  <div class="collection-list-item">
    <img :src="imageUrl" class="image" />
    <div class="meta">
      <router-link :to="route" class="name">{{ name }}</router-link>
      <p class="desc">{{ packageCountText }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    imageUrl: { type: String, default: "" },
    name: { type: String, default: "" },
    packageCount: { type: Number, default: 0 },
    route: { type: Object, default: () => ({}) }
  },
  computed: {
    packageCountText() {
      const packageCount = this.packageCount.toLocaleString();

      return `มี ${packageCount} แพ็กเกจย่อย`;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
$logoSize: 120px;

.collection-list-item {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;

  align-items: center;

  border-bottom: $border;
  padding: ($space / 2) $space;

  > .image {
    display: block;

    border-radius: 8px;
    width: $logoSize;
    height: 90px;
    flex: 0 0 $logoSize;
  }

  > .meta {
    padding-left: $space;
    display: block;

    flex-grow: 1;
  }
}

.meta {
  margin-top: -4px;
  min-width: 0;

  > .name {
    display: inline-block;
    font-size: 1rem;

    &:hover {
      color: black;
    }
  }

  > .desc {
    overflow: hidden;
    height: 23px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.meta p {
  line-height: 1.6;
  font-size: 0.9rem;
  color: #777;
}

.provider {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  > .logo {
    margin-right: 12px;

    border-radius: $border-radius;
    width: 24px;
    height: 24px;
  }
}
</style>
